import { StrictMode } from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { StoreProvider } from './store';
import { startServiceWorker } from './lib/sw';
import './styles/base.css';
import './styles/arena.css';

// errors only: no session replay, tracing or IP/cookies (most players are under 18)
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) Sentry.init({ dsn, environment: import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined, release: import.meta.env.VITE_RELEASE as string | undefined, sendDefaultPii: false, tracesSampleRate: 0 });

startServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <StoreProvider>
        <App />
      </StoreProvider>
    </BrowserRouter>
  </StrictMode>,
);
